export default "__VITE_ASSET__CQSbF9bs__"